import { SlideLoveCover } from './SlideLoveCover'
import { SlideLifecycleTail } from './SlideLifecycleTail'
import { SlideFormatByPhase } from './SlideFormatByPhase'
import { SlideAgencyOfRecord } from './SlideAgencyOfRecord'
import { SlideSnakDefinition } from './SlideSnakDefinition'
import { SlideOperatingScale } from './SlideOperatingScale'
import { SlideCampaignFlowMockups } from './SlideCampaignFlowMockups'
import { Slide03Background } from './Slide03Background'
import { SlideMasterSnaks } from './SlideMasterSnaks'
import { SlideGovernanceView } from './SlideGovernanceView'
import { SlideCountryBrandView } from './SlideCountryBrandView'
import { SlideCustomerJourneyExamples } from './SlideCustomerJourneyExamples'
import { SlideCampaignCostCalculator } from './SlideCampaignCostCalculator'
import { SlideCostDisruptor } from './SlideCostDisruptor'

export const slides = [
  SlideLoveCover,
  SlideAgencyOfRecord,
  SlideCostDisruptor,
  SlideOperatingScale,
  SlideLifecycleTail,
  SlideFormatByPhase,
  SlideSnakDefinition,
  SlideCustomerJourneyExamples,
  SlideCampaignFlowMockups,
  Slide03Background,
  SlideMasterSnaks,
  SlideGovernanceView,
  SlideCountryBrandView,
  SlideCampaignCostCalculator,
]

export const slideTitles: { section: string; title: string }[] = [
  { section: 'Cover', title: 'All You Need Is Love' },
  { section: '02', title: 'Snak Agency of Record' },
  { section: '03', title: 'The Campaign Cost Disruptor' },
  { section: '04', title: 'Built for Continued Campaigns' },
  { section: '05', title: 'Three Priorities Across the Product Lifecycle' },
  { section: '06', title: 'As Familiarity Grows, Format Shortens' },
  { section: '07', title: 'HCPs Don’t Lack Content. They Lack Time.' },
  { section: '08', title: 'Snaks Throughout the Customer Journey' },
  { section: '09', title: 'Banner to Snak to Insight' },
  { section: '10', title: 'More Channels to Share' },
  { section: '11', title: 'Suggested Further Master Snaks' },
  { section: '12', title: 'One Governance View' },
  { section: '13', title: 'By Country and by Brand' },
  { section: '14', title: 'Interactive Campaign Cost Calculator' },
]
